import { ListItemButton, MenuItem, ListItemIcon as MuiListItemIcon } from '@mui/material';
import { styled, useTheme } from '@mui/material/styles';

export const TranslateButtonContainer = styled(ListItemButton)(({ theme }) => ({
  borderRadius: '12px',
  margin: theme.spacing(0, 0.5, 0, 1),
  padding: theme.spacing(0, 0),

  '&.Mui-selected': {
    '& .MuiListItemIcon-root': {
      backgroundColor: 'transparent',

      '&:hover': {
        backgroundColor: theme.palette.primary.states.selected,
        boxShadow: 'none',
      },
    },
  },
}));

export const TranslateButtonItem = styled(MenuItem)(({ theme }) => ({
  width: '100%',
  justifyContent: 'flex-start',
  gap: theme.spacing(2),
  padding: theme.spacing(1, 0.65),
  color: theme.palette.text.primary,
  [theme.breakpoints.down('md')]: {
    minHeight: '32px',
    padding: 0,
  },
}));

export const ListItemIcon = styled(MuiListItemIcon)(() => ({
  minWidth: '48px',
  height: '48px',
  color: 'inherit',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  borderRadius: '8px',
  transition: 'all 0.2s ease-in-out',
  '& svg': {
    fontSize: '24px',
  },
}));

export const ListItemButtonText = styled('div')(({ isSelected }: { isSelected?: boolean }) => {
  const theme = useTheme();

  return {
    padding: `0 ${theme.spacing(1.25)}`,
    color: isSelected ? theme.palette.primary.main : 'inherit',
  };
});
